var PatientSelectionDataTestIdEnum = /* @__PURE__ */ ((PatientSelectionDataTestIdEnum2) => {
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_MODAL"] = "patient-selection--modal";
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_LIST_TITLE"] = "patient-selection--list-title";
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_LIST_SUBTITLE"] = "patient-selection--list-subtitle";
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_LIST_CLOSE_BUTTON"] = "patient-selection--list-close-button";
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_AGE_WARNING"] = "patient-selection--age-warning";
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_OPTION"] = "patient-selection--option";
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_CREATE_BUTTON"] = "patient-selection--create-button";
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_SEARCH_ANOTHER_BUTTON"] = "patient-selection--search-another-button";
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_CREATE_STEP"] = "patient-selection--create-step";
  PatientSelectionDataTestIdEnum2["PATIENT_SELECTION_CREATE_STEP_CLOSE_BUTTON"] = "patient-selection--create-step-close-button";
  return PatientSelectionDataTestIdEnum2;
})(PatientSelectionDataTestIdEnum || {});
export {
  PatientSelectionDataTestIdEnum
};
